// src/utils/storage.js
import { decryptData } from '../sections/auth/jwt/encryptionUtils';

function getPrefix() {
    const path = window.location.pathname.split("/")[1];
    return (window._env_ && window._env_.STORAGE_PREFIX) || path || "default";
  }
  
  const originalGetItem = Storage.prototype.getItem;
  const originalSetItem = Storage.prototype.setItem;
  const originalRemoveItem = Storage.prototype.removeItem;
  
  // List of keys that should be encrypted/decrypted
  const ENCRYPTED_KEYS = [
    'loginId',
    'siteCode',
    'siteName',
    'employeeId',
    'employeeName',
    'department'
  ];
  
  // Helper function to check if a key should be decrypted
  const shouldDecrypt = (key) => {
    return ENCRYPTED_KEYS.some(encKey => key.includes(encKey));
  };
  
  Storage.prototype.getItem = function (key) {
    try {
      const rawValue = originalGetItem.call(this, key);
      if (rawValue !== null) {
        // Decrypt if the key is in the encrypted keys list
        if (shouldDecrypt(key)) {
          return decryptData(rawValue);
        }
        return rawValue;
      }
  
      const prefixedValue = originalGetItem.call(this, `${getPrefix()}_${key}`);
      // Decrypt if the key is in the encrypted keys list
      if (prefixedValue !== null && shouldDecrypt(key)) {
        return decryptData(prefixedValue);
      }
      return prefixedValue;
    } catch (e) {
      console.error("Failed to get localStorage key", key, e);
      return null;
    }
  };
  
  Storage.prototype.setItem = function (key, value) {
    try {
      return originalSetItem.call(this, `${getPrefix()}_${key}`, value);
    } catch (e) {
      console.error("Failed to set localStorage key", key, e);
    }
  };
  
  Storage.prototype.removeItem = function (key) {
    try {
      originalRemoveItem.call(this, key);
      originalRemoveItem.call(this, `${getPrefix()}_${key}`);
    } catch (e) {
      console.error("Failed to remove localStorage key", key, e);
    }
  };
  
  // Keep wrapper for compatibility with automatic decryption
  export const storage = {
    get: (key) => localStorage.getItem(key), // Now automatically decrypts
    set: (key, value) => localStorage.setItem(key, value),
    remove: (key) => localStorage.removeItem(key),
    
    // Clear only login-related data for the current prefix
    clearLoginData: () => {
      try {
        const loginKeys = [
          'loginId',
          'siteCode',
          'siteName',
          'employeeId',
          'employeeName',
          'department',
          'ldapAuthWw',
          'activeClient' // Clear client selection when clearing login data
        ];
        
        // Remove login keys from localStorage
        loginKeys.forEach((key) => localStorage.removeItem(key));
        
        // Also clear accessToken from sessionStorage
        sessionStorage.removeItem('accessToken');
      } catch (e) {
        console.error("Failed to clear login data", e);
      }
    },
    
    // Clear all data with the current prefix (kept for backward compatibility)
    clearAll: () => {
      try {
        const prefix = getPrefix();
        Object.keys(localStorage)
          .filter((k) => k.startsWith(`${prefix}_`))
          .forEach((k) => localStorage.removeItem(k));
      } catch (e) {
        console.error("Failed to clear localStorage", e);
      }
    },
  };